export default __webpack_public_path__ + "maps-examples-offline-storage-960-192796e4e7d767fed899730bad082564.png";